import { defineMessages } from 'react-intl';
import {
  EDITOR_TYPE_BUYER_NAME,
  EDITOR_TYPE_ORDER_TAGS,
  EDITOR_TYPE_UNDEFINED,
  EDITOR_TYPE_RECIPIENT_NAME,
  EDITOR_TYPE_ADDRESS_LINE_1,
  EDITOR_TYPE_ADDRESS_LINE_2,
  EDITOR_TYPE_BUYER_ID,
  EDITOR_TYPE_CITY,
  EDITOR_TYPE_CUSTOM_FIELD_1,
  EDITOR_TYPE_CUSTOM_FIELD_2,
  EDITOR_TYPE_CUSTOM_FIELD_3,
  EDITOR_TYPE_INTERNAL_NOTES,
  EDITOR_TYPE_ITEM_NAME,
  EDITOR_TYPE_ITEM_SKU,
  EDITOR_TYPE_NOTES_TO_BUYER,
  EDITOR_TYPE_NOTES_FROM_BUYER,
  EDITOR_TYPE_ORDER_NUMBER,
  EDITOR_TYPE_POSTAL_CODE,
  EDITOR_TYPE_RECIPIENT_COMPANY,
  EDITOR_TYPE_ORDER_SOURCE,
  EDITOR_TYPE_USPS_ZONE,
  EDITOR_TYPE_ADDRESS_VERIFICATION,
  EDITOR_TYPE_ASSIGNED_USER,
  EDITOR_TYPE_LINE_ITEMS,
  EDITOR_TYPE_AMOUNT_PAID,
  EDITOR_TYPE_ORDER_SUBTOTAL,
  EDITOR_TYPE_ORDER_TOTAL,
  EDITOR_TYPE_SHIPPING_PAID,
  EDITOR_TYPE_TAX_PAID,
  EDITOR_TYPE_TOTAL_QUANTITY,
  EDITOR_TYPE_CARRIER,
  EDITOR_TYPE_MARKETPLACE,
  EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED,
  EDITOR_TYPE_STORE,
  EDITOR_TYPE_SHIP_FROM,
  EDITOR_TYPE_SHOPIFY_SHIP_FROM,
  EDITOR_TYPE_DATE_PAID,
  EDITOR_TYPE_SHIP_BY_DATE,
  EDITOR_TYPE_ORDER_DATE,
  EDITOR_TYPE_WAREHOUSE_LOCATION,
  EDITOR_TYPE_SHIP_TO_COUNTRY,
  EDITOR_TYPE_IS_GIFT,
  EDITOR_TYPE_IS_INTERNATIONAL,
  EDITOR_TYPE_STATE,
  EDITOR_TYPE_RESIDENTIAL_INDICATOR,
  EDITOR_TYPE_PACKAGE_TYPE,
  EDITOR_TYPE_SHIPPING_ACCOUNT,
  EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT,
  EDITOR_TYPE_ORDER_WEIGHT,
  EDITOR_TYPE_REQUESTED_SERVICE_MAPPED,
  EDITOR_TYPE_PAYMENT_METHOD,
  EDITOR_TYPE_SELLER_BRAND,
  EDITOR_TYPE_FULFILLMENT_PROVIDER,
  EDITOR_TYPE_DELIVER_BY_DATE,
  EDITOR_TYPE_ORDER_IMPORT_TIME,
} from '../filter-editor-type';

const messages = defineMessages({
  fulfillmentProviderEditor: {
    description: 'name displayed in the drop down that allows the user to setup a rule by FulfillmentProvider (3PL)',
    defaultMessage: 'Fulfillment Provider',
    id: '9zJJv5',
  },
  customerNameEditor: {
    description: 'Filter editor Customer Name editor type',
    defaultMessage: 'Customer',
    id: 'Qwwtep',
  },
  orderTagsEditor: {
    description: 'Filter editor Order Tags editor type',
    defaultMessage: 'Order Tags',
    id: '74VCSe',
  },
  unsupportedEditor: {
    description: 'Filter editor applied filter editor type cant be found',
    defaultMessage: 'Unsupported editor type',
    id: 'yZe/+/',
  },
  recipientNameEditor: {
    description: 'Filter editor recipient name',
    defaultMessage: 'Recipient Name',
    id: '1+9yA/',
  },
  address1Editor: {
    description: 'Filter editor address line 1',
    defaultMessage: 'Address Line 1',
    id: '1uBZfc',
  },
  address2Editor: {
    description: 'Filter editor address line 2',
    defaultMessage: 'Address Line 2',
    id: '+E2wCR',
  },
  buyerIdEditor: {
    description: 'Filter editor buyer id',
    defaultMessage: 'Buyer ID',
    id: '472wyb',
  },
  cityEditor: {
    description: 'Filter editor city',
    defaultMessage: 'City',
    id: 'm3Tl9N',
  },
  customField1Editor: {
    description: 'Filter editor custom field 1',
    defaultMessage: 'Custom Field 1',
    id: 'SdFiDZ',
  },
  customField2Editor: {
    description: 'Filter editor custom field 2',
    defaultMessage: 'Custom Field 2',
    id: '6FRl0f',
  },
  customField3Editor: {
    description: 'Filter editor custom field 3',
    defaultMessage: 'Custom Field 3',
    id: 'TOkF8t',
  },
  internalNotesEditor: {
    description: 'Filter editor internal notes',
    defaultMessage: 'Internal Notes',
    id: 'AqDDPW',
  },
  itemNameEditor: {
    description: 'Filter editor Item Name',
    defaultMessage: 'Item Name',
    id: 'KRVTyB',
  },
  itemSkuEditor: {
    description: 'Filter editor Item SKU',
    defaultMessage: 'Item Sku',
    id: 'RvgZRa',
  },
  notesToBuyerEditor: {
    description: 'Filter editor Notes to the Buyer',
    defaultMessage: 'Notes to the Buyer',
    id: 'SoNW0R',
  },
  notesFromBuyerEditor: {
    description: 'Filter editor Notes from the Buyer',
    defaultMessage: 'Notes from the Buyer',
    id: '07+MXV',
  },
  orderNumberEditor: {
    description: 'Filter editor Order Number',
    defaultMessage: 'Order #',
    id: '47G04P',
  },
  paymentMethodEditor: {
    description: 'Filter editor Payment Method',
    defaultMessage: 'Payment Method',
    id: 'woRGqh',
  },
  postalCodeEditor: {
    description: 'Filter editor Postal Code',
    defaultMessage: 'Postal Code',
    id: 'w0+BAN',
  },
  recipientCompanyEditor: {
    description: 'Filter editor Recipient Company',
    defaultMessage: 'Recipient Company',
    id: '865Rtx',
  },
  orderSourceEditor: {
    description: 'Filter editor Order Source',
    defaultMessage: 'Order Source',
    id: 'yoDaN0',
  },
  uspsZoneEditor: {
    description: 'Filter editor USPS Zone',
    defaultMessage: 'USPS Zone',
    id: 'ORER6g',
  },
  addressVerificationEditor: {
    description: 'Filter editor Address Verification',
    defaultMessage: 'Address Verified',
    id: 'Ru1yCC',
  },
  assignedUserEditor: {
    description: 'Filter editor Assigned User',
    defaultMessage: 'Assigned User',
    id: 'UJ06a9',
  },
  lineItemsEditor: {
    description: 'Filter editor Line Items Count',
    defaultMessage: '# of Line Items',
    id: 'XWoqCA',
  },
  amountPaidEditor: {
    description: 'Filter editor Amount Paid Count',
    defaultMessage: 'Amount Paid',
    id: 't/Ak56',
  },
  orderSubtotalEditor: {
    description: 'Filter editor Order Subtotal',
    defaultMessage: 'Order Subtotal',
    id: 'xI09/S',
  },
  orderTotalEditor: {
    description: 'Filter editor Order Total',
    defaultMessage: 'Order Total',
    id: '2L5Cnu',
  },
  shippingPaidEditor: {
    description: 'Filter editor Shipping Paid',
    defaultMessage: 'Shipping Paid',
    id: 'SbsjZv',
  },
  taxPaidEditor: {
    description: 'Filter editor Tax Paid',
    defaultMessage: 'Tax Paid',
    id: 'd14QdY',
  },
  totalQuantityEditor: {
    description: 'Filter editor Total Quantity',
    defaultMessage: 'Total Quantity',
    id: 'Qa3mOC',
  },
  carrierEditor: {
    description: 'Filter editor Carrier',
    defaultMessage: 'Carrier',
    id: 'xsRU58',
  },
  marketplaceEditor: {
    description: 'Filter editor Marketplace',
    defaultMessage: 'Marketplace',
    id: 'NRz8nJ',
  },
  requestedServiceUnmappedEditor: {
    description: 'Filter editor Requested Service (unmapped)',
    defaultMessage: 'Requested Service (Marketplace Value)',
    id: '+bN09X',
  },
  storeEditor: {
    description: 'Filter editor Store',
    defaultMessage: 'Store',
    id: 'g3BPgk',
  },
  shipFromEditor: {
    description: 'Filter editor Ship From Location',
    defaultMessage: 'Ship From Location',
    id: 'Jo83so',
  },
  datePaidEditor: {
    description: 'Filter editor Date Paid',
    defaultMessage: 'Date Paid',
    id: 'm0aAtD',
  },
  shipByEditor: {
    description: 'Filter editor Ship By Date',
    defaultMessage: 'Ship By Date',
    id: 'CsCzBt',
  },
  orderDateEditor: {
    description: 'Filter editor Order Date',
    defaultMessage: 'Order Date',
    id: 'tOyPlw',
  },
  warehouseEditor: {
    description: 'Filter editor Warehouse Location',
    defaultMessage: 'Warehouse Location',
    id: 'LbQTKk',
  },
  countryEditor: {
    description: 'Filter editor Country',
    defaultMessage: 'Country',
    id: 'fDZLOC',
  },
  isGiftEditorType: {
    description: 'Filter editor Is Gift',
    defaultMessage: 'Gift Order',
    id: 'MGjKki',
  },
  isInternationalEditorType: {
    description: 'Filter editor Is International',
    defaultMessage: 'International Order',
    id: '7KgfB7',
  },
  stateEditorType: {
    description: 'Filter editor State',
    defaultMessage: 'State',
    id: 'f5zCPY',
  },
  residentialEditorType: {
    description: 'Filter editor Residential/Commercial indicator',
    defaultMessage: 'Residential / Commercial',
    id: 'ja7ylL',
  },
  packageEditorType: {
    description: 'Filter editor Package Type editor',
    defaultMessage: 'Package',
    id: 'qzCqqQ',
  },
  shippingAccountEditorType: {
    description: 'Filter editor Shipping Account',
    defaultMessage: 'Shipping Account',
    id: '69pRXm',
  },
  orderWeightEditor: {
    description: 'Filter editor Order Weight editor',
    defaultMessage: 'Order Weight',
    id: 'KdHPOT',
  },
  mappedServiceEditor: {
    description: 'Filter editor Requested Service (Mapped)',
    defaultMessage: 'Requested Service (Mapped)',
    id: 'dVPajm',
  },
  brandEditor: {
    description: 'Filter editor Seller Brand',
    defaultMessage: 'Brand',
    id: 'lUCHeO',
  },
  deliverByEditor: {
    description: 'Filter editor Deliver By Date',
    defaultMessage: 'Deliver By Date',
    id: 'LtsjwL',
  },
  shopifyShipFromEditor: {
    description: 'Filter editor Shopify Ship From Location',
    defaultMessage: 'Shopify Ship From Location',
    id: '/FF2me',
  },
  orderImportTimeEditor: {
    description: 'Filter editor Order Import Time - the time the order was imported to ShipStation',
    defaultMessage: 'Order Import Time',
    id: 'jsOPpL',
  },
});

const typeToNameMap = {
  [EDITOR_TYPE_BUYER_NAME]: messages.customerNameEditor,
  [EDITOR_TYPE_ORDER_TAGS]: messages.orderTagsEditor,
  [EDITOR_TYPE_UNDEFINED]: messages.unsupportedEditor,
  [EDITOR_TYPE_RECIPIENT_NAME]: messages.recipientNameEditor,
  [EDITOR_TYPE_ADDRESS_LINE_1]: messages.address1Editor,
  [EDITOR_TYPE_ADDRESS_LINE_2]: messages.address2Editor,
  [EDITOR_TYPE_BUYER_ID]: messages.buyerIdEditor,
  [EDITOR_TYPE_CITY]: messages.cityEditor,
  [EDITOR_TYPE_CUSTOM_FIELD_1]: messages.customField1Editor,
  [EDITOR_TYPE_CUSTOM_FIELD_2]: messages.customField2Editor,
  [EDITOR_TYPE_CUSTOM_FIELD_3]: messages.customField3Editor,
  [EDITOR_TYPE_INTERNAL_NOTES]: messages.internalNotesEditor,
  [EDITOR_TYPE_ITEM_NAME]: messages.itemNameEditor,
  [EDITOR_TYPE_ITEM_SKU]: messages.itemSkuEditor,
  [EDITOR_TYPE_NOTES_TO_BUYER]: messages.notesToBuyerEditor,
  [EDITOR_TYPE_NOTES_FROM_BUYER]: messages.notesFromBuyerEditor,
  [EDITOR_TYPE_ORDER_NUMBER]: messages.orderNumberEditor,
  [EDITOR_TYPE_POSTAL_CODE]: messages.postalCodeEditor,
  [EDITOR_TYPE_RECIPIENT_COMPANY]: messages.recipientCompanyEditor,
  [EDITOR_TYPE_ORDER_SOURCE]: messages.orderSourceEditor,
  [EDITOR_TYPE_USPS_ZONE]: messages.uspsZoneEditor,
  [EDITOR_TYPE_ADDRESS_VERIFICATION]: messages.addressVerificationEditor,
  [EDITOR_TYPE_ASSIGNED_USER]: messages.assignedUserEditor,
  [EDITOR_TYPE_LINE_ITEMS]: messages.lineItemsEditor,
  [EDITOR_TYPE_AMOUNT_PAID]: messages.amountPaidEditor,
  [EDITOR_TYPE_ORDER_SUBTOTAL]: messages.orderSubtotalEditor,
  [EDITOR_TYPE_ORDER_TOTAL]: messages.orderTotalEditor,
  [EDITOR_TYPE_SHIPPING_PAID]: messages.shippingPaidEditor,
  [EDITOR_TYPE_TAX_PAID]: messages.taxPaidEditor,
  [EDITOR_TYPE_TOTAL_QUANTITY]: messages.totalQuantityEditor,
  [EDITOR_TYPE_CARRIER]: messages.carrierEditor,
  [EDITOR_TYPE_MARKETPLACE]: messages.marketplaceEditor,
  [EDITOR_TYPE_REQUESTED_SERVICE_UNMAPPED]: messages.requestedServiceUnmappedEditor,
  [EDITOR_TYPE_STORE]: messages.storeEditor,
  [EDITOR_TYPE_SHIP_FROM]: messages.shipFromEditor,
  [EDITOR_TYPE_SHOPIFY_SHIP_FROM]: messages.shopifyShipFromEditor,
  [EDITOR_TYPE_DATE_PAID]: messages.datePaidEditor,
  [EDITOR_TYPE_SHIP_BY_DATE]: messages.shipByEditor,
  [EDITOR_TYPE_ORDER_DATE]: messages.orderDateEditor,
  [EDITOR_TYPE_WAREHOUSE_LOCATION]: messages.warehouseEditor,
  [EDITOR_TYPE_SHIP_TO_COUNTRY]: messages.countryEditor,
  [EDITOR_TYPE_IS_GIFT]: messages.isGiftEditorType,
  [EDITOR_TYPE_IS_INTERNATIONAL]: messages.isInternationalEditorType,
  [EDITOR_TYPE_STATE]: messages.stateEditorType,
  [EDITOR_TYPE_RESIDENTIAL_INDICATOR]: messages.residentialEditorType,
  [EDITOR_TYPE_PACKAGE_TYPE]: messages.packageEditorType,
  [EDITOR_TYPE_SHIPPING_ACCOUNT]: messages.shippingAccountEditorType,
  [EDITOR_TYPE_EXTERNAL_SHIPPING_ACCOUNT]: messages.shippingAccountEditorType,
  [EDITOR_TYPE_ORDER_WEIGHT]: messages.orderWeightEditor,
  [EDITOR_TYPE_REQUESTED_SERVICE_MAPPED]: messages.mappedServiceEditor,
  [EDITOR_TYPE_PAYMENT_METHOD]: messages.paymentMethodEditor,
  [EDITOR_TYPE_SELLER_BRAND]: messages.brandEditor,
  [EDITOR_TYPE_FULFILLMENT_PROVIDER]: messages.fulfillmentProviderEditor,
  [EDITOR_TYPE_DELIVER_BY_DATE]: messages.deliverByEditor,
  [EDITOR_TYPE_ORDER_IMPORT_TIME]: messages.orderImportTimeEditor,
};

export const editorTypeNameFromEditorType = (editorType) => {
  return typeToNameMap[editorType];
};
